import { runInAction } from 'mobx';
import presizeBackendRest from '../../services/presize-backend-rest';
import { SizingStore } from './sizing-store';

export class GetSilosAction {
  async getSilos(this: SizingStore, cgCodes: string[]): Promise<void> {
    runInAction(() => {
      this.loadingSilos = true;
    });

    try {
      const uniqueCgCodes = Array.from(new Set(cgCodes.filter(Boolean)));
      const response = await presizeBackendRest.getSilos({
        brand_code: this.brandCode,
        ...(uniqueCgCodes.length ? { cg_codes: uniqueCgCodes.join(',') } : {}),
      });

      const siloNames = Array.from(new Set(response.silos.filter(Boolean)));

      runInAction(() => {
        this.silos = siloNames;
      });
    } finally {
      runInAction(() => {
        this.loadingSilos = false;
      });
    }
  }
}
